"use client";
import React, { ReactNode, createContext, useContext } from "react";
import usePubSub, { PubSub } from "src/customHooks/usePubSub";

const PubSubContext = createContext<PubSub>({} as PubSub);

export const usePubSubContext = () => {
  return useContext(PubSubContext);
};

export const PubSubProvider = ({ children }: { children: ReactNode }) => {
  const pubSub = usePubSub(); // Your existing pub-sub hook

  return (
    <PubSubContext.Provider value={pubSub}>{children}</PubSubContext.Provider>
  );
};
